module.exports = __webpack_public_path__ + "static/media/storygraph.2c564d74.svg";